import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42d724b2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d724b2')) {
      api.createRecord('42d724b2', component.options)
    } else {
      api.reload('42d724b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42d724b2&", function () {
      api.rerender('42d724b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/activityType/index.vue"
export default component.exports